import { Button, Group } from '@mantine/core';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSelect from '@/srcV2/components/LanguageSelect';
import { PATHS } from '@/srcV2/constants';
import { useHostContext } from '@/srcV2/context/HostContext.tsx';
import { partnerMetadata } from '@/srcV2/services/PartnerMetadata.ts';
// utils
import { cn } from '@/srcV2/utils';

interface HeaderProps {
	className?: string;
}

const Header = ({ className }: HeaderProps) => {
	const logoSrc =
		partnerMetadata.getDarkLogoUrl(true) || partnerMetadata.getDarkLogoUrl();
	const { localization } = useHostContext();
	const navigate = useNavigate();
	const handleNavigate = useCallback(() => {
		navigate(PATHS.creatorIndex);
	}, [navigate]);

	if (!logoSrc) {
		console.error('No logo configured for partner:', partnerMetadata.getId());
	}

	return (
		<header
			className={cn(
				'flex w-full items-center justify-between gap-5 py-8 m-0!',
				className
			)}
		>
			{logoSrc && (
				<Button
					h="auto"
					onClick={handleNavigate}
					p={8}
					variant="transparent"
				>
					<img
						alt={`${partnerMetadata.getName()} Logo`}
						className="max-h-16 w-auto object-contain logo"
						onError={(e) => {
							e.currentTarget.style.display = 'none';
						}}
						src={logoSrc}
					/>
				</Button>
			)}

			<Group>
				{partnerMetadata.isLocalizationEnabled() && localization && (
					<LanguageSelect />
				)}
			</Group>
		</header>
	);
};

export default Header;
